import logging from 'node-logging-js';
import jsb from 'node-jsb';
import Swiper from 'swiper';
import Masonry from 'masonry-layout';

/* Documentation http://idangero.us/swiper/ */
class Tiles {
    constructor(element, options) {
        logging.applyLogging(this, 'Tiles');
        this.logDebug('options:', options);
        this.element = element;
        this.swiper = this.element.querySelector('.js-swiper');
        this.thumbClick = this.element.querySelectorAll('.js-click');
        this.close = this.element.querySelector('.js-close');

        this.initialize();
    }

    initialize() {
        var msnry = new Masonry( '.tiles-list', {
            itemSelector: '.tiles-item',
            columnWidth: '.grid-sizer',
            percentPosition: true
        });

        this.Tiles = new Swiper(this.swiper, {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        for (let i = 0; i < this.thumbClick.length; i++) {
            this.thumbClick[i].addEventListener('click', () => {
                var slideIndex = this.thumbClick[i].getAttribute('data-index');
                this.Tiles.slideTo(slideIndex);
                this.element.classList.add('is-open');
            });
        }

        this.close.addEventListener('click', () => {
            this.element.classList.remove('is-open');
        });

    }
}

jsb.registerHandler('Tiles', Tiles);
export default Tiles;
